// zh.js
export default {
  common: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    export:'导出',
    setLgSuccess: '设置语言成功',
  },
  header: {
    "ourProduct": "我们的产品",
    "appProduct": "UUPay APP",
    "posProduct": "UUPay 收款机",
    "monitorProduct": "UUPay 控制台",
    "price": "价格",
    "resource": "实用资源",
    "blog": "网志",
    "document": "教学文件",
    "case": "商户成功案例",
    "company": "公司",
    "aboutUs": "关于我们",
    "job": "工作机会",
    "contactUs": "联络我们",
    "news": "公司新闻",
    "toDownload": "立即使用",
  },
  footer: {
    "address": "香港01广场1号大厦01楼001室",
    "news": "媒体报导",
    "privacy": "隐私政策声明",
    "privacyDetail": "条款及细则",
    "copyright": "版权所有",
    "phone": "+110 1000 1000",
    "email": "UUPay123@.com",
    "about": "关于",
    "cooperate": "合作机会",
  },
  home: {
    
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh.js